
    // this file was auto generated by python script
    import ToggleLeft from './ToggleLeft';
    export default ToggleLeft;
    